import React, { memo } from 'react';
import { css } from '@emotion/react';

const Background = ({
  imageLink,
  children,
  onClick,
}: {
  imageLink: string;
  children: JSX.Element | JSX.Element[];
  onClick: () => void;
}) => {
  const backgroundImg = css`
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-image: ${`url(` + imageLink + `)`};
    background-position: 50% 75%;
    background-size: cover;
    object-fit: fill;
  `;

  return (
    <div css={backgroundImg} onClick={onClick}>
      <div css={gradient}>{children}</div>
    </div>
  );
};

const gradient = css`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to top,
    rgba(237, 237, 238, 0) 45%,
    rgba(237, 237, 238, 0.05) 50%,
    rgba(237, 237, 238, 0.1) 55%,
    rgba(237, 237, 238, 0.2) 60%,
    rgba(237, 237, 238, 0.3) 65%,
    rgba(237, 237, 238, 0.4) 70%,
    rgba(237, 237, 238, 0.5) 75%,
    rgba(237, 237, 238, 0.6) 80%,
    rgba(237, 237, 238, 0.7) 85%,
    rgba(237, 237, 238, 0.8) 90%,
    rgba(237, 237, 238, 0.9) 95%,
    rgba(237, 237, 238, 1) 100%
  );
`;

export default memo(Background);
